import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openItemModifierModal, openItemNoteModal, addModalItemID, addModalCurrentOrderItemID, orderDelete } from '../actions/index';

class OrderItems extends Component {

  // Add the item ID to the modal state
  handleItemModifierModal(orderItemsID) {
    this.props.addModalCurrentOrderItemID(orderItemsID).then( () => {
        this.props.openItemModifierModal();
    });
  }

  // When the user hits the delete button
  handleItemDelete(orderItemsID) {
    this.props.orderDelete(orderItemsID);
  }

  // When the user hits the modifier button
  handleItemNoteModal(orderItemsID) {
    this.props.addModalCurrentOrderItemID(orderItemsID).then( () => {
      this.props.openItemNoteModal();
    });
  }

  // Render the html for each item in the current_order
  renderOrderItems() {
    var items = Object.values(this.props.current_order.items);

    return items.map( (item, index) => {

      // Decide how to render the modifier button if the item has them or not
      let modifierButton = null;
      if (item.has_modifiers) {
        modifierButton =
          <a href={"#" + item.order_items_id} onClick={event => this.handleItemModifierModal(item.order_items_id)}>
            <i className="ti-plus"></i>
          </a>;
      } else {
        modifierButton = <a href="#blank">&nbsp;</a>;
      }

      return(
        <div className="box bg-white product product-4" key={index}>
          <div className="p-content">
            <div className="clearfix">
              <span className="h5">1 - {item.name}</span>
              <div className="p-price h5 float-xs-right">${item.price.toFixed(2)}</div>
            </div>
            <div>
              {this.renderModifiers(item.cat_id, item.id, item.modifiers)}
            </div>
            <div>
              {this.renderItemNote(item.note)}
            </div>
          </div>

          <div className="p-links">
            <div className="row no-gutter">
              <div className="col-xs-4 pl-item">
                {modifierButton}
              </div>
              <div className="col-xs-4 pl-item">
                <a href={"#" + item.order_items_id} onClick={event => this.handleItemNoteModal(item.order_items_id)}>
                  <i className="ti-pencil"></i>
                </a>
              </div>
              <div className="col-xs-4 pl-item">
                <a href={"#" + item.order_items_id} onClick={event => this.handleItemDelete(item.order_items_id)}>
                  <i className="ti-close"></i>
                </a>
              </div>
            </div>
          </div>
      </div>
      );
    });
  }

  // Render the note for an item in the current order
  renderItemNote(itemNote) {
    if (itemNote) {
      return (
        <div>
          <br />
          <span className="text-danger">* Note: </span> {itemNote}
        </div>
      );
    }
  }

  // Render the modifiers for an item
  renderModifiers(categoryID, itemID, itemModifiers) {
    // If the modifiers is empty, return empty span tag
    if (Object.keys(itemModifiers).length === 0) {
      return <span></span>;
    }

    // Hold all the mod html in this array
    let modifierText = [];

    // Loop through the modifiers and create html for each one
    Object.keys(itemModifiers).forEach(groupID => {
      Object.keys(itemModifiers[groupID]).forEach(modifierID => {
        modifierText.push(
          <div key={modifierID}>
            <span>
              {this.props.restaurant.menuItems[categoryID].items[itemID].modifiers[groupID].modifiers[modifierID].name}
            </span>
            <div className="p-price float-xs-right">
              ${this.props.restaurant.menuItems[categoryID].items[itemID].modifiers[groupID].modifiers[modifierID].price.toFixed(2)}
            </div>
          </div>
        );
      });
    });

    return modifierText;
  }

  render() {
      return(
        <div>
          {this.renderOrderItems()}
        </div>
      );
  }
}

function mapStateToProps({ current_order, modals, restaurant }) {
  return { current_order, modals, restaurant };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { openItemModifierModal, openItemNoteModal, addModalItemID, addModalCurrentOrderItemID, orderDelete }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderItems);



// WEBPACK FOOTER //
// ./src/components/order_items.js